import { css } from '@emotion/react'
import { ReportLabelInspectionArea } from '@ulysses-inc/harami_api_client'
import { Space } from 'antd'
import { Text } from 'src/components/nativeCompat/Text'
import {
  labelAreaResultStatusColor,
  labelAreaResultStatusLabel,
} from 'src/features/labelCheck/constants/labelAreaResult'
import { getAreaDisplayValues } from './getAreaDisplayValues'

type Props = {
  labelAreaResult: ReportLabelInspectionArea
}

export const LabelAreaResultSection = ({ labelAreaResult: area }: Props) => {
  const displayValues = getAreaDisplayValues(area)
  return (
    <Space key={area.labelInspectionAreaId} css={styles.labelAreaResultSection}>
      <Text
        style={{
          color: labelAreaResultStatusColor[area.status],
          fontWeight: 'bold',
        }}
      >
        {labelAreaResultStatusLabel[area.status]}
      </Text>
      <Text>{area.name}</Text>
      {displayValues.kind === 'matching' && (
        <>
          <Text>正解値：{displayValues.matchingValue}</Text>
          <Text>読取値：{displayValues.extractedValue}</Text>
        </>
      )}
      {displayValues.kind === 'extractedOnly' && (
        <Text>読取値：{displayValues.extractedValue}</Text>
      )}
    </Space>
  )
}

const styles = {
  labelAreaResultSection: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
}
